var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateTimings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C38.8075 0 50 11.1925 50 25C50 38.8075 38.8075 50 25 50C11.1925 50 0 38.8075 0 25C0 11.1925 11.1925 0 25 0ZM22.675 13.9525C22.2122 13.9525 21.7684 14.1363 21.4411 14.4636C21.1138 14.7908 20.93 15.2347 20.93 15.6975V29.65C20.93 30.615 21.71 31.395 22.675 31.395H36.6275C36.862 31.4039 37.096 31.3654 37.3153 31.2817C37.5346 31.1981 37.7348 31.0711 37.9039 30.9083C38.0729 30.7455 38.2074 30.5502 38.2993 30.3343C38.3912 30.1183 38.4385 29.886 38.4385 29.6513C38.4385 29.4165 38.3912 29.1842 38.2993 28.9682C38.2074 28.7523 38.0729 28.557 37.9039 28.3942C37.7348 28.2314 37.5346 28.1044 37.3153 28.0208C37.096 27.9371 36.862 27.8986 36.6275 27.9075H24.4175V15.6975C24.4175 15.2351 24.234 14.7917 23.9073 14.4645C23.5806 14.1373 23.1374 13.9532 22.675 13.9525Z",
    fill: "#FD9902"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateTimings);
export default __webpack_public_path__ + "static/media/UpdateTimings.dd2a24defd0be387c24768910358c2b2.svg";
export { ForwardRef as ReactComponent };